export default [
  {
    path: '/assetqlts/:key?',
    name: 'assetQLTSPage',
    component: () => import('@/views/assetQLTS/index.vue'),
    meta: {},
  },
];
